import OpenPlayerJS from "openplayerjs";

window.addEventListener("load", function () {
    const video = document.querySelector("#player");

    const player = new OpenPlayerJS("player", {
        mode: "fill",
        controls: {
            alwaysVisible: false,
            layers: {
                // left: ["play", "volume", "time"],
                middle: [],
                right: ["fullscreen", "levels"],
            },
        },
        showLoaderOnInit: true,
        progress: {
            duration: 0,
            showCurrentTimeOnly: true,
        },
        live: {
            showLabel: false,
            showProgress: false,
        },
        hls: {
            startLevel: -1,
            enableWorker: true,
            liveDurationInfinity: true,
        },
    });

    player.addElement({
        id: "watermark",
        type: "div",
        content:
            '<a href="https://brusqueaovivo.com" target="_blank"><img src="' +
            video.dataset.watermark +
            '" alt="Brusque ao Vivo"></a>',
        position: "main",
        click: () => {},
    });

    player.init();
});
